// src/utils/constants.js
// Shared constants used across multiple components.

import { GHOST_THRESHOLDS } from './ghostThresholds.js';

// Canonical auto-ghost threshold (global default). Per-state/per-agency
// overrides live in ghostThresholds.js — re-exported here so existing
// GHOST_AGE_DAYS imports keep working unchanged. (3.1a)
export const GHOST_AGE_DAYS = GHOST_THRESHOLDS.global;

export const STAGE_OPTIONS = [
  { label: '⏳ Pending', value: 'Pending' },
  { label: '💲 Quote', value: 'Quote' },
  { label: '💰 Paid', value: 'Paid' },
  { label: '▶️ Video', value: 'Video' },
  // Text-style ✖ (U+FE0E), not the ❌ emoji: it takes the text color, so
  // it shows white on the red pill instead of red on red.
  { label: '✖︎ No Footage', value: 'No Footage' },
  { label: '👻 Ghosted', value: 'Ghosted' },
  { label: '💪 Action', value: 'Action' },
  { label: '🟢 Received', value: 'Received' },
  { label: '⚖️ Open', value: 'Open' },
  { label: '🚀 Bullpen', value: 'Bullpen' },
  { label: '🚀💥 BullpenX', value: 'BullpenX' },
  { label: '🪦 Kill', value: 'Kill' },
  { label: '📌 Covered', value: 'Covered' },
];

// The Filter by Stage dropdown and the record modal's Stage field keep the
// red ❌ emoji: there's no red pill behind them, so the reason for the
// text-style ✖ above doesn't apply.
export const STAGE_FILTER_OPTIONS = STAGE_OPTIONS.map(o =>
  o.value === 'No Footage' ? { ...o, label: '❌ No Footage' } : o
);

export const RECORDS_MODAL_HEADERS = [
  { title: 'Record', key: 'name', width: '200px' },
  { title: 'Request Date', key: 'displayDate', width: '120px' },
  { title: 'Stage', key: 'stage', width: '120px' },
  { title: 'Rating', key: 'rating', align: 'center', width: '90px' },
  { title: 'How Found', key: 'howFound', width: '150px' },
  { title: 'Cost', key: 'cost', width: '100px', align: 'end' },
  { title: 'Subject Matter', key: 'subjectMatter', width: '250px' },
  { title: 'Misc.', key: 'misc', width: '200px' },
  { title: 'Update', key: 'update', width: '200px' },
  { title: 'Other Info', key: 'otherInfo', width: '200px' },
];

export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
];

// Duration code → plain English label
export const DURATION_LABELS = {
  '0D':   'Today',
  '3D':   '3 Days',
  '1W':   '1 Week',
  '2W':   '2 Weeks',
  '1M':   '1 Month',
  '1.5M': '6 Weeks',
  '2M':   '2 Months',
  '3M':   '3 Months',
  'Custom': 'Custom Date',
};

// Returns plain English label for a duration code, falls back to the code itself
export function formatDuration(code) {
  if (!code) return '';
  if (code === 'Custom') return 'Custom Date';
  return DURATION_LABELS[code] || code;
}